import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M4 5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-5.89a4 4 0 0 1-2.603-.963L9.692 5.481A2 2 0 0 0 8.39 5H4ZM0 7a4 4 0 0 1 4-4h4.39a4 4 0 0 1 2.603.963l1.815 1.556A2 2 0 0 0 14.11 6H20a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
